module.exports = require("./sr-Cyrl-ME.d.ts");